// src/pages/Expertise.jsx
import React from 'react';
import expertiseBg from '../assets/images/companyImg.JPG'; 
import clientAvatar1 from '../assets/images/agriculture-logo.png'; // Adjust path if necessary
import clientAvatar2 from '../assets/images/innovation.jpg'; // Adjust path if necessary
import clientAvatar3 from '../assets/images/inn.jpg';


function Expertise() {
  return (
    // Outermost div: Acts as the container for the entire page and its background
    <div className="position-relative overflow-hidden">
      {/* Background Image Layer: Positioned absolutely to cover the entire outermost div */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          backgroundImage: `url(${expertiseBg})`, // Use the imported background image
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed', // Makes the background image static (parallax effect)
          opacity: 0.3, // Adjust opacity as needed for readability
          zIndex: 0, // Ensures it's behind the content
        }}
      ></div>

      {/* Main Content Wrapper: All visible page content goes here, positioned above the background */}
      <div className="container py-3 position-relative z-1 text-dark"> {/* Added position-relative and z-1 */}
        <h1 className="mb-4 text-center display-4 fw-bold ">Technical Expertise</h1>
        <p className="lead text-center mb-5 ">
          LIYO & SONS GROUP (PTY) Ltd delivers expert-level services in civil, structural, and mechanical domains. Our team of specialists
          is equipped to manage highly technical projects with precision, safety, and innovation.
        </p>

        {/* Core Expertise Areas */}
        <section className="py-3  mb-5 position-relative z-1"> {/* Changed bg-light to bg-white and added z-1 */}
          <h3 className="mb-4 text-center">Key Service Domains</h3>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                {/* Urban & Rural Roads */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-white text-dark text-center">
                      <i className="bi bi-signpost-2 display-5 text-warning mb-3"></i> {/* Example Icon */}
                      <h5 className="card-title ">Urban & Rural Roads</h5>
                      <p className="card-text">
                        We provide complete roadworks solutions, including earthworks, stormwater control, and road surfacing. Our
                        approach emphasizes long-term durability and traffic safety compliance.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Water & Sanitation */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body text-dark bg-white text-center">
                      <i className="bi bi-droplet display-5 text-warning mb-3"></i> 
                      <h5 className="card-title">Water & Sanitation</h5>
                      <p className="card-text">
                        Our sanitation services include water treatment plant (WTP) and sewage system installations, supported by qualified plumbing
                        teams and environmental safety protocols.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Structural Buildings */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body text-dark bg-white text-center">
                      <i className="bi bi-building display-5 text-warning mb-3"></i> 
                      <h5 className="card-title">Structural Buildings</h5>
                      <p className="card-text">
                        We offer structural design, construction, and project supervision of buildings — with services ranging from residential
                        developments to industrial projects, all executed with technical accuracy.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Specialized Systems */}
        <section className="py-3 mb-5 position-relative z-1"> 
          <h3 className="mb-4 text-center">Specialized System Installations</h3>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="row row-cols-1 row-cols-md-2 g-4">
                {/* Mechanical Systems (HVAC & Ventilation) */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body text-dark bg-white">
                      <h5 className="card-title d-flex align-items-center mb-3">
                        <i className="bi bi-fan display-6 text-warning me-3"></i>Mechanical Systems (HVAC & Ventilation)
                      </h5>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">Central chiller systems</li>
                        <li className="list-group-item">VRF (Variable Refrigerant Flow) systems</li>
                        <li className="list-group-item">Split-type systems</li>
                        <li className="list-group-item">Building Management Systems (BMS)</li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* Electrical Systems */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body text-dark bg-white">
                      <h5 className="card-title d-flex align-items-center mb-3">
                        <i className="bi bi-lightning display-6 text-warning me-3"></i>Electrical Systems
                      </h5>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">High and low voltage installations</li>
                        <li className="list-group-item">Main feeders and generator setups</li>
                        <li className="list-group-item">Lighting systems, CCTV, security</li>
                        <li className="list-group-item">Data, telephone, earthing, and lightning protection</li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* Plumbing Systems */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body text-dark bg-white">
                      <h5 className="card-title d-flex align-items-center mb-3">
                        <i className="bi bi-tools display-6 text-warning me-3"></i>Plumbing Systems
                      </h5>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">Sanitary systems</li>
                        <li className="list-group-item">Sewage treatment solutions</li>
                        <li className="list-group-item">General water supply and drainage systems</li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* Fire Protection Systems */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body text-dark bg-white">
                      <h5 className="card-title d-flex align-items-center mb-3">
                        <i className="bi bi-fire display-6 text-warning me-3"></i>Fire Protection Systems
                      </h5>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">Sprinkler systems</li>
                        <li className="list-group-item">Hose reels and fire alarms</li>
                        <li className="list-group-item">Gas suppression systems (FM200, CO₂)</li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* Process & Utility Installations */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body  text-dark bg-white">
                      <h5 className="card-title d-flex align-items-center mb-3">
                        <i className="bi bi-gear display-6 text-warning me-3"></i>Process & Utility Installations
                      </h5>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">Gas piping and tank installations</li>
                        <li className="list-group-item">Process cooling and ventilation</li>
                        <li className="list-group-item">Utility piping (steam, compressed air, etc.)</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="my-5 py-3 text-center position-relative z-1">
            <h2 className="mb-4 text-warning">What Our Clients Say</h2> {/* Changed title to H2 */}
            {/* <p className="lead mb-4">We are proud to collaborate with industry leaders.</p> */}

            <div className="row justify-content-center g-4"> {/* Removed bg-white w-100 */}
                {/* Review Card 1 */}
                <div className="col-12 col-md-6 col-lg-4"> {/* Adjusted column sizes for testimonials */}
                    <div className="review-card h-100 shadow-lg"> {/* Added custom class 'review-card' */}
                        <div className="card-body text-dark bg-white ">
                            <img
                                src={clientAvatar1}
                                alt="Client Name 1"
                                className="rounded-circle mb-3 review-avatar" // Added custom class 'review-avatar'
                            />
                            <h5 className="card-title text-warning mb-1">Sandile Mpeti</h5>
                            <p className="small mb-3">Service: Public Facility Renovation</p>
                            <p className="card-text fst-italic">
                                "LIYO & SONS transformed our old municipal facility into a modern, functional space. Their attention to detail and commitment to quality were outstanding!"
                            </p>
                        </div>
                    </div>
                </div>

                {/* Review Card 2 */}
                <div className="col-12 col-md-6 col-lg-4">
                    <div className="review-card h-100 shadow-lg">
                        <div className="card-body bg-white text-dark">
                            <img
                                src={clientAvatar2}
                                alt="Client Name 2"
                                className="rounded-circle mb-3 review-avatar"
                            />
                            <h5 className="card-title text-warning mb-1">Thami Nkabinde</h5>
                            <p className="small mb-3">Service: Urban Road Rehabilitation</p>
                            <p className="card-text fst-italic">
                                "The road rehabilitation project greatly improved accessibility in our township. The team was efficient, professional, and delivered on time."
                            </p>
                        </div>
                    </div>
                </div>

                {/* Review Card 3 */}
                <div className="col-12 col-md-6 col-lg-4">
                    <div className="review-card h-100 shadow-lg">
                        <div className="card-body bg-white text-dark">
                            <img
                                src={clientAvatar3}
                                alt="Client Name 3"
                                className="rounded-circle mb-3 review-avatar"
                            />
                            <h5 className="card-title text-warning mb-1">Marc Vesagie</h5>
                            <p className="small mb-3">Service: Security Fencing Installation</p>
                            <p className="card-text fst-italic">
                                "We needed a robust security solution, and LI-YO & SONS delivered exactly that. The new fencing is top-notch, and their installation team was very professional."
                            </p>
                        </div>
                    </div>
                </div>

                {/* You can add more review cards here following the same structure */}

            </div>
        </section>
      </div> 
    </div> 
  );
}

export default Expertise;
